import { iws_ChangeWholeCursorStyles } from "../../../IsiPage.ts";
import { iws_eventTarget } from "../../../tools.ts";
import { IIsiGridOnMouseDownEventArgs } from "../../../IsiWebGUI/IsiFW/Components/Grid/IsiGridBase";
import { IsiGridView } from "../../../IsiWebGUI/IsiFW/Components/Grid/IsiGridView";

/***
 * Classe de gestion du drag n'drop de la grille dans le formulaire.
 */
export class IsiGridDragNDropManager {

    /**
     * Informations du row draggé.
     */
    private _draggedAndDropedRow;

    /**
     * Délégué avant le drop des valeurs de la ligne.
     */
    private _beforeGridDropDlg: (ctrlDroppedId, isCtrlKey, shiftKey) => number;

    /**
     * Délégué après le début du drag.
     */
    private _afterGridDragStartDlg: (grid:IsiGridView, row) => void;


    /**
     * Délégué après le changement du style du curseur lors du drag n drop.
     */
    private _afterDragNDropCursorChangeDlg: (on:boolean) => void;

    /**
     * Div contenant les grilles des DA.
     */
    private _divDetail: HTMLElement;

    /**
     * Constructeur de la classe.
     */
    constructor() {
    }

    /**
     * Affecte le délégué utilisé avant le drop d'une valeur.
     * @param dlg
     */
    public setBeforeDropDlg(dlg: (ctrlDroppedId, ctrlKey, shiftKey) => number) {
        this._beforeGridDropDlg = dlg;
    }

    /**
     * Affecte le délégué utilisé pour changer le curseur
     * @param dlg
     */
    public setDragNDropCursorChangeDlg(dlg: (on: boolean) => void) {
        this._afterDragNDropCursorChangeDlg = dlg;
    }
    /**
     * Affecte le délégué utilisé après le début du drag
     * @param dlg
     */
    public setAfterGridDragStartDlg(dlg: (grid:IsiGridView, row) => void) {
        this._afterGridDragStartDlg = dlg;
    }

    public init() {
        // Evenements
        // Capture de l'evenement mouse up, pour dropper la chaine de caracteres.
        if (window.jQuery && (!window.IsiDocumentIsBindable || window.IsiDocumentIsBindable())) {
            jQuery(document).on("mouseup", (evt) => {
                this.onMouseUpOnForm(evt);
            });
        }
    }
    /**
     * Gestion du mouseup pour gérer le drop de la valeur
     * @param event
     * @returns
     */
    public onMouseUpOnForm(event) {
        const evt = iws_event(event);
        // Il faut qu'une valeur soit draggee...
        if (this._draggedAndDropedRow && evt) {
            this._dragDropOnMouseUpOnForm(evt);
        }
        // Quoiqu'il advienne, on annule le Drag 'n Drop.
        return this._resetDragAndDrop();
    }

    public getDragNDropInfo():any {
        return this._draggedAndDropedRow;
    }

    /**
 * ORIC - 060505 - [DRAGDROP] : Reset des variables globales et du style du pointeur quand on perd le Drag 'n Drop.
 * @returns
 */
    private _resetDragAndDrop() {

        // LBRI - 2007.04.02 - [DYSF:18034] : On reinitialise le style du curseur que dans le cas ou la page n'est pas en train de se recharger.
        if (!window.bLoadInProgress) {
            // RAZ du curseur de souris.
            this._setCursorForDragDrop(false);
        }
        this.resetDroppedRow();

        return true;
    }


    /**
     * Affichage ou non du curseur de drag&drop
     * @param {any} on
     */
    private _setCursorForDragDrop(on:boolean) {
        // Modification du style de pointeur de la souris.	
        iws_ChangeWholeCursorStyles("auto");
        if (this._afterDragNDropCursorChangeDlg) {
            this._afterDragNDropCursorChangeDlg(on)
        }
    }
    /**
     * Active l'observation du drag n'drop pour une donnée associée.
     * @param gridId
     */
    public observeGridDragNDrop(gridView:IsiGridView) {
        // Ajout de la gestion du add_onMouseDown pour faire fonctionner le drag&drop
     
        gridView.add_onMouseDown((sender:IsiGridView,args: IIsiGridOnMouseDownEventArgs) => {
            uiCore.gridDragNDropManager.mouseDownOnCellGrid(sender, args);
                });
    }


    /* VLEB - 2007.09.04 - [TACHE:13429]
    * Fonction appelee avant le Drag'n Drop. Fonction virtuelle a surcharger si besoin.
    * @param sCtrlDroppedId					: Identifiant du controle qui a subi le drop.
    * @param oDraggedAndDropedRow				: Objet infragistic correspondant a la ligne du depart du drag.
    * @param sDisplayedAssociatedViewName		: Nom de la vue actuellement affichee.
    * @param bctrlKey							: Permet de savoir si la touche ctrl est pressee.
    *
    *
    *	Les differentes valeur de retour sont : 
    *		- 0 : On executera tout le code du drag'n drop et du after drag'n drop.
    *		- 1	: On executera seulement le code du after drag'n drop et pas celui du drag'n drop.
    *		- 2 : On stoppera le traitement entier (Drag'n drop et after Drag'n drop).
    */
    private _beforeGridDrop(ctrlDroppedId, isCtrlKey, shiftKey) {
        if (this._beforeGridDropDlg) {
            return this._beforeGridDropDlg(ctrlDroppedId, isCtrlKey, shiftKey);
        } else {
            return 0;
        }
    }

    private _dragDropOnMouseUpOnForm(evt) {

        // Si le controle ou l'on drop la valeur est un text, alors on place la valeur.
        const exp = TEXTBOX + "$|" + TEXTBOX_FAST_ID + "$|" + TEXTBOX_MULTI + "$|" + ISIMEMORICHTXT + "$|" + VIEW_DATE_TIME + "_t$";
        const re = new RegExp(exp);

        // Variable lié au contrôle et éventuellement à un composant
        let ctrlDropped;
        let component;
        let componentFnGetValue;
        let componentFnSetValue;

        // Nouvelle valeur
        let sNewValue = "";

        // Cet objet represente le controle qui a declenche le dernier evenement en date, autrement dit, le mouse up !
        ctrlDropped = iws_eventTarget(evt);
        // Si le controlDropped n'a pas d'id ou n'est pas un "contrôle classique", on essaye de rechercher un composant associé
        // Dans le cas d'un composant RichText, on peut drop du texte dans des balises <div>, <br> etc. enfantes
        if (!re.test(ctrlDropped.id)) {
            component = uiCore.componentManager.getParentComponentFromHtmlChildElement(evt.target);
            if (component) {
                ctrlDropped = component._element;
                switch (component.constructor.__typeName) {
                    case 'IsiFW.Components.Editor.IsiRichText':
                        componentFnGetValue = component.getContent;
                        componentFnSetValue = component.setPlainTextContent;
                        break;
                }
            }
        }

        if (ctrlDropped) {

            if (re.test(ctrlDropped.id) && !ctrlDropped.readOnly) {


                const iReturn = this._beforeGridDrop(ctrlDropped.id, evt.ctrlKey, evt.shiftKey);

                if (iReturn < 2) {
                    if (iReturn < 1) {
                        let draggedString = this.dragDropSafeGet(null);

                        // Si la touche [CTRL] est pressee, alors on concatene au lieu de remplacer.
                        if (evt.ctrlKey) {

                            // On va chercher la valeur courante
                            let currentValue = '';
                            if (component) {
                                currentValue = componentFnGetValue.call(component);
                            } else {
                                currentValue = ctrlDropped.value;
                            }

                            //DEV57993 LLGU 16/11/2012 ajout d'un traitement spécial pour l'écran modèle fusion
                            if (isiApp.screen.pageName == "ADM079") {
                                sNewValue = currentValue + draggedString + "\n";
                            }
                            else {
                                sNewValue = currentValue + "\r\n" + draggedString;
                            }
                        } else {
                            //DEV57993 LLGU 16/11/2012 ajout d'un traitement spécial pour l'écran modèle fusion
                            if (isiApp.screen.pageName == "ADM079") {
                                sNewValue = draggedString + "\n";
                            }
                            else {
                                sNewValue = draggedString;
                            }
                        }

                        // Affectation de la nouvelle valeur au controle.
                        if (component) {
                            componentFnSetValue.call(component, sNewValue);
                        } else {
                            ctrlDropped.value = sNewValue;
                        }

                        // On provoque l'evenement OnChange sur le controle ou on a droppe la valeur.
                        iws_TriggerOnChange(ctrlDropped);
                    }

                    // LBRI - 2007.04.02 - [DYSF:16827] : Il faut specifier le debut du drag'n drop.
                    window.gbDragDropInProgress = true;

                    // On declenche l'after dragdrop apres un timeout, afin que le controle "aie le temp"
                    // de changer de valeur.
                    setTimeout(() => {
                        this._afterGridDrop();
                    }, 0);
                }
            }
            else {
                // VLEB - 2006.09.20 - [DYSF:15282] : Reinitialise la variable contenant la ligne droppee.
                this._draggedAndDropedRow = null;
            }
        }
    }
    /**
     * Vide les information dropées
     */
    public resetDroppedRow() {
        this._draggedAndDropedRow = null;
    }

    /**
     * Extrait les données de l'objet de drag&drop
     * @param {any} prop
     * @returns
     */
    public dragDropSafeGet(prop) {

        
        if (!this._draggedAndDropedRow) { return null; }

        if (prop) {
            const val = this._draggedAndDropedRow.row[prop];
            if (typeof (val) === undefined) { return ""; }
            return val;
        } else {
            const val = this._draggedAndDropedRow.cellFormattedValue;
            if (typeof (val) === undefined) { return ""; }
            return val;
        }
    }

    // ORIC - 060809 - [DEV7932] : Fonction qui lance une action lorsqu'un drag drop est effectue.
    // Cette action depend de la vue associee affichee.
    //--- MODIFICATION --------------------------------------------------------------------------
    //- Auteur      : AMON
    //- Date        : 04/12/2009
    //- Description : DYSF 30765 modification getMenuItemIDFromObjectKey
    //-------------------------------------------------------------------------------------------
    private _afterGridDrop() {

        const actionAfterDragDrop = uiCore.associatedViewManager.currentContext.associatedViewState.actionAfterDragNDrop;
        let stopDrag = true;

        if (actionAfterDragDrop && actionAfterDragDrop !== "") {
            if (uiCore.menuManager.getEntryById(actionAfterDragDrop) != null) {
                uiCore.menuManager.openMenuById(actionAfterDragDrop);
                stopDrag = false;
            }
        }

        if (stopDrag) {
            // LBRI - 2007.04.02 - [DYSF:16827] : Il faut specifier la fin du drag'n drop.
            window.gbDragDropInProgress = false;
        }

    }

    
    /**
     * lancé sur le click d'une Grille
     * @param {IIsiGridOnMouseDownEventArgs} args
     */
    public mouseDownOnCellGrid(sender: IsiGridView, args: IIsiGridOnMouseDownEventArgs) {
        if (args.record.row !== null) {
            this._draggedAndDropedRow = args.record;
            this._onMouseDownOnCellGrid(sender, args.containerId);
        }
    }

    // ORIC - 060504 - Sauvegarde du texte de la cellule sur un mousedown de la souris (Drag 'n Drop)
    // Parameters :
    //		gridName (String) : The ID of the grid calling the function.
    //		id (String) : The ID of the element the cursor was over when clicked.
    //		button (Number) : The number that represents the pressed mouse button. 0 - left, 1 - middle, 2 - right.
    private _onMouseDownOnCellGrid(grid :IsiGridView, containerId) {

        // met le focus sur la grille
        isiApp.focus.onDetail();

        this._setCursorForDragDrop(true);

        // On va bloquer toute tentative de selection (en effet, certains drag 'n drop provoque
        // la selection de texte, ce qui est desagreable...) a partir de la grille.
        // Ce blocage sera leve des qu'une selection passera en mode edition.
        // [GELA] - DYSF45280 - Compatibilite IE9
        const container = jQuery("#" + containerId)
        if (container.length > 0) {
            container[0].onselectstart = function () {
                return false;
            };
        }
        

        // On ajoute un listener a l'evenement mouseup sur la div detail, afin d'annuler le
        // drag 'n drop si la souris est relachee. NB : la meme fonction est lancee sur le
        // "document" sur un mouse up (cf. plus haut).
        const divDet = this._getDivDetail();
        if (divDet) {
            jQuery(divDet).on("on", (evt) => {
                this.onMouseUpOnForm(evt)
            });
        }

        this._afterGridDrag(grid, this._draggedAndDropedRow);
    }
    private _getDivDetail() {
        if (!this._divDetail) {
            this._divDetail = document.getElementById(DIV_DETAIL);
        }
        return this._divDetail;
    }
    public unRegisterDragNDrop() {
        const divDet = this._getDivDetail();
        if (divDet) {
            jQuery(divDet).off();
        }
    }

    /**
     * GELA - 2007.09.12 - Fonction appelee avant le Drag'n Drop.
     * @param {any} row Les données relatives à la ligne de grille utilisée pour le drag&drop
     */
    private _afterGridDrag(grid:IsiGridView, row) {
        if (this._afterGridDragStartDlg) {
            this._afterGridDragStartDlg(grid, row);
        }
    }

}
